<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="ma-4">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-account-details</v-icon>회원정보 수정
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          회원정보
        </v-card-subtitle>
      </v-toolbar>

      <v-card outlined tile class="ma-4 mt-0">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNickId"  label="Id" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="이름" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.LevNm" label="직위" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.National" label="국적" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Birth" label="생년월일" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.Email" dense persistent-placeholder class="">
                <template v-slot:label>
                  <div>메일주소<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.Tel" @click="CertifyByPhone()" dense persistent-placeholder readonly>
                <template v-slot:label>
                  <div>휴대전화번호<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append-outer>
                  <v-btn @click="CertifyByPhone()" dark x-small>인증</v-btn>
                </template>
              </v-text-field>
              <!-- <v-text-field v-model="editedItem.Tel" :disabled="bCertifyIng" @keyup="bAuthCheck = false" @keyup.enter="CertifyByPhone()" @click:append="CertifyByPhone()" :loading="bSendingP" append-icon="send" dense persistent-placeholder type="number">
                <template v-slot:label>
                  <div>휴대전화번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field> -->
            </v-col>
            <!-- <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cInputCodeP" @keyup.enter="CheckAuthNum();" :disabled="!bCertifyIng" label="휴대전화번호 인증" :class="{'' : bCertifyIng}" dense persistent-placeholder>
                <template v-slot:label>
                  휴대전화번호 인증<strong v-if="bCertifyIng" class="red--text">*</strong>
                </template>
                <template v-slot:append>
                  <div v-if="bCertifyIng" class="d-flex">
                    <v-icon @click="CheckAuthNum()" class="mr-2">mdi-check</v-icon>
                    <div style="width:40px" class="pt-1">{{cCertifyTime}}</div>
                  </div>
                </template>
              </v-text-field>
            </v-col> -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.Pwd" @keyup="filteringHandler" @click:append="bPwd = !bPwd" :class="{'test_password_style' : bPwd}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.Pwd)" :append-icon="bPwd ? 'mdi-eye-off': 'mdi-eye'" dense persistent-placeholder ref="cPwdRef">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">기존 비밀번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.Pwd1" @keyup="filteringHandler1" @click:append="bPwd1 = !bPwd1" :class="{'test_password_style' : bPwd1, '' : editedItem.Pwd1 != '' || editedItem.Pwd2 != ''}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.Pwd1)" :append-icon="bPwd1 ? 'mdi-eye-off': 'mdi-eye'" dense persistent-placeholder hint="Essential" ref="cPwd1Ref">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">신규 비밀번호<strong v-if="editedItem.Pwd1 != '' || editedItem.Pwd2 != ''" class="red--text">*</strong></div>
                </template>
                <template v-slot:message="{   }">
                  <div style="-webkit-text-security: none;">영문+숫자 (10자리 ~ 30자리) 또는 영문+특수기호 (10자리 ~ 30자리) 또는 영문+숫자+특수기호(8자리 ~ 30자리)</div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.Pwd2" @keyup="filteringHandler2" @click:append="bPwd2 = !bPwd2" :class="{'test_password_style' : bPwd2,'' : editedItem.Pwd1 != '' || editedItem.Pwd2 != ''}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.Pwd2)" :append-icon="bPwd2 ? 'mdi-eye-off': 'mdi-eye'" dense persistent-placeholder ref="cPwd2Ref">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호 확인<strong v-if="editedItem.Pwd1 != '' || editedItem.Pwd2 != ''" class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <!-- <v-text-field v-model="editedItem.Pwd2" @click:append="bPwd2 = !bPwd2" :class="{'test_password_style' : bPwd2}" dense persistent-placeholder :rules="[rules.check]" :append-icon="bPwd2 ? 'mdi-eye-off': 'mdi-eye'">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호 확인</div>
                </template>
              </v-text-field> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-divider class="ml-4 mr-4"></v-divider>


      <!-- 차량 정보 입력칸 -->
      <v-card-text>
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          차량정보
        </v-card-subtitle>
      </v-card-text>
      <v-card outlined tile class="ma-4 mt-0">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.CarType" label="차종" dense persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.CarNo" label="차량번호" dense persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 파일 첨부 칸 -->
      <v-divider class="ml-4 mr-4 mt-5"></v-divider>
      <v-card-text class="pb-0">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          첨부파일
        </v-card-subtitle>
      </v-card-text>
      <v-card-text>
        <v-card class="d-flex flex-wrap essetial_card" flat outlined tile>
          <v-card width="170" flat class="ml-4 mr-4 pa-4 essetial_card">
            <v-img
              :aspect-ratio="2/1"
              :src="sNowPath"
              contain
              style="height:100px"
              max-height="150px"
            ></v-img>
            <v-file-input
              v-on:change="onSelFile(NowSelFile)"
              v-model="NowSelFile"
              class="mt-2"
              accept="image/png"
              placeholder="파일선택"
              dense
            ></v-file-input>
          </v-card>
          <v-card class="essetial_card" flat>
            <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
              증명사진
            </v-card-subtitle>
            <v-card-text class="text-caption">
              JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
              다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
              (첨부 할 수 있는 파일의 최대 크기는 10MB 까지 입니다)
            </v-card-text>
          </v-card>
        </v-card>
      </v-card-text>

      <!-- <v-card-text class="pb-0 mt-4">
        <div class="hidden-sm-and-down">
          <v-card outlined tile class="d-flex pt-4">
            <v-card height="150" flat class="ml-4 mr-4">
              <v-img
                :aspect-ratio="1/1"
                :src="sNowPath"
                contain
                style="height:100px"
                max-width="150px"
                max-height="150px"
              ></v-img>
              <v-file-input
                v-on:change="onSelFile(NowSelFile)"
                v-model="NowSelFile"
                class="mb-n7"
                accept="image/jpeg"
                placeholder="파일선택"
                dense
              ></v-file-input>
            </v-card>
            <v-card flat class="word_keeper" width="calc(100w)">
              <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
                증명사진
              </v-card-subtitle>
              <v-card-text class="text-caption">
                JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
                다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                (첨부 할 수 있는 파일의 최대 크기는 10MB 까지 입니다)
              </v-card-text>
            </v-card>
          </v-card>
        </div>
        
        <div class="hidden-md-and-up">
          <v-card outlined tile class="pt-4">
            <v-card height="150" flat class="ml-4 mr-4">
              <v-img
                :aspect-ratio="1/1"
                :src="sNowPath"
                contain
                style="height:100px"
                max-width="150px"
                max-height="150px"
              ></v-img>
              <v-file-input
                v-on:change="onSelFile(NowSelFile)"
                v-model="NowSelFile"
                class="mb-n7"
                accept="image/jpeg"
                placeholder="파일선택"
                dense
              ></v-file-input>
            </v-card>
            <v-card flat class="word_keeper" width="calc(100w)">
              <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
                증명사진
              </v-card-subtitle>
              <v-card-text class="text-caption">
                JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
                다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                (첨부 할 수 있는 파일의 최대 크기는 10MB까지 입니다)
              </v-card-text>
            </v-card>
          </v-card>
        </div>
      </v-card-text> -->

      <v-card-text align="center" class="hidden-sm-and-down">
        <v-divider class="ma-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="EditCustomInfo()" dark class="ml-2 mr-2"><v-icon class="mr-2">edit</v-icon>수정</v-btn>
        <v-btn @click="dialog = true;" color="error" class="ml-2 mr-2"><v-icon class="mr-2">delete</v-icon>탈퇴</v-btn>
      </v-card-text>
      
      <v-card-text align="center" class="hidden-md-and-up">
        <v-divider class="ma-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon>dashboard</v-icon></v-btn>
        <v-btn @click="EditCustomInfo()" dark class="ml-2 mr-2"><v-icon>edit</v-icon></v-btn>
        <v-btn @click="dialog = true;" color="error" class="ml-2 mr-2"><v-icon>delete</v-icon></v-btn>
      </v-card-text>
    </v-card>
    
    <!-- 회원 탈퇴 확인 다이올로그 창 -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card flat>
        <v-card-title>
          탈퇴를 하게되면 이용하셨던 모든 정보가 삭제됩니다. 정말로 탈퇴하시겠습니까??
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" align="right">
              <v-btn @click="dialog = false;" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
              <v-btn @click="DelCustom()" dark class="ml-2 mr-2"><v-icon class="mr-2">delete</v-icon>탈퇴</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "../BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

export default {
  data: () => ({
    OpenWindow : null,
    dialog : false,
    loading : false,
    bSendingE : false,
    bSendingP : false,
    bPwd : true,
    bPwd1 : true,
    bPwd2 : true,
    NowSelFile : null,
    bAuthCheck : false,
    bCertifyIng : false,
    cCertifyTime : "",
    cCodeP : "",
    sNowPath : "",
    bCertifyE : false,
    bCertifyP : false,
    interval : {},
    cCircularTime : 0,
    oCheckEmail : {
      bResult : false,
      cEmail : "",
    },
    // rules : {},
    editedItem : {
      Email : "",
      Tel : "",
      cCode : "",
      cAuthType : "",
      cAuthDI : "",
      CarNo : "",
      CarType : "",
      Path : "",
      FileId : "",
      Pwd : "",
      Pwd1 : "",
      Pwd2 : "",
      cInputCodeP : "",
    },
  }),

  computed: {  
    ...mapState(["CustomInfo","FMaxSize3","zFileType","cAES256Encrypt"]),
  },

  created() {
    this.cCertifyTime = ""
  },

  mounted() {
    window.addEventListener("message", this.onSendMessage);
    this.editedItem.Email = this.CustomInfo.Email
    this.editedItem.Tel = this.CustomInfo.Tel
    this.editedItem.CarNo = this.CustomInfo.CarNo
    this.editedItem.CarType = this.CustomInfo.CarType
    this.editedItem.FileId = this.CustomInfo.FileId
    this.editedItem.Path = this.CustomInfo.Path
    this.sNowPath = BasicInfo.FILE_API + this.CustomInfo.Path;
  },

  beforeDestroy(){
    clearInterval(this.interval)
    window.removeEventListener("message", this.onSendMessage);
  },

  methods : {
    CopyByCtrlC(event,value) {
      if (event.key.toUpperCase() == "C") {
        navigator.clipboard.writeText(value)
      }
    },

    filteringHandler(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.cPwdRef.lazyValue = ResultWord
      this.editedItem.Pwd = ResultWord
    },

    filteringHandler1(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.cPwd1Ref.lazyValue = ResultWord
      this.editedItem.Pwd1 = ResultWord
    },

    filteringHandler2(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.cPwd2Ref.lazyValue = ResultWord
      this.editedItem.Pwd2 = ResultWord
    },

    // 1초 마다 함수 실행하기
    CountTime() {
      this.cCircularTime = 180
      this.cCertifyTime = "3:00"
      this.bCertifyIng = true
      this.interval = setInterval(() => {
        this.cCircularTime -= 1
        this.cCertifyTime = Util.ChangeNumToMin(this.cCircularTime)
        if (this.cCircularTime == 0) {
          this.ResetCertify()
          clearInterval(this.interval)
        }
      }, 1000)
    },

    ResetCertify(){
      this.bAuthCheck = false
      this.bCertifyIng = false
      this.editedItem.cInputCodeP = ""
      this.cCodeP = ""
      clearInterval(this.interval)
    },

    CertifyByPhone() {
      this.bAuthCheck = false
      if (this.OpenWindow != null) {
        this.OpenWindow.close();
      }

      this.OpenWindow = window.open(BasicInfo.URL_KCB_API + "phone_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");
    },

    onSendMessage(event) {
      if (event.data.RSLT_CD == "B000") {
        this.editedItem.Tel = event.data.TEL_NO
        this.editedItem.cCode = event.data.Code
        this.editedItem.cAuthType = event.data.AuthType
        this.editedItem.cAuthDI = event.data.AuthDI
        this.bAuthCheck = true
        // this.$emit('ClosePledge',event.data)
      } else {
        return
      }
    },

    // 파일 선택시 정보 불러오기
    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          this.sNowPath = BasicInfo.FILE_API + this.CustomInfo.Path
          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
      }

      try {
        reader.readAsDataURL(NowSelFile)
      } catch (error) {
        this.sNowPath = BasicInfo.FILE_API + this.CustomInfo.Path
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    // 파일 저장하기
    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(BasicInfo.UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId,
                formData,
                {
                headers: {
                  // "Authorization": this.CustomInfo.Token,
                  'Content-Type': 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              this.loading = false;
              resolve(null);
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!" + err)
          })
      ));
    },

    // 비밀번호 유효성검사
    CheckPW(cPwd,cCustomNickId,cBirth) {
      if(!Util.CheckPWFormNew(cPwd)){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호는 영문+숫자(10자리 ~ 30자리) 또는 영문+특수기호(10자리 ~ 30자리) 또는 영문+숫자+특수기호(8자리 ~ 30자리)로 설정해주세요.");
        return false;
      }

      if(/(\w)\1\1/.test(cPwd)){
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호는 같은 문자를 3번 이상 사용하실 수 없습니다.");
        return false;
      }

      if(cPwd.search(cCustomNickId)>-1){
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 아이디가 포함되었습니다.");
        return false;
      }
      
      if(cPwd.search(cBirth)>-1){
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 생년월일이 포함되었습니다.");
        return false;
      }

      return true;
    },

    // 회원정보 수정하기
    async EditCustomInfo(){
      this.editedItem.Pwd1 = Util.RemoveBlank(this.editedItem.Pwd1)
      this.editedItem.Pwd2 = Util.RemoveBlank(this.editedItem.Pwd2)

      if (this.editedItem.Tel != this.CustomInfo.Tel && !this.bAuthCheck) {
        EventBus.$emit("onShowMsgBox", "휴대전화번호가 기존에 저장된 정보와 다릅니다.","변경을 원하시면 인증을 먼저 진행해 주세요.");
        return;
      }
      
      if (this.bCertifyIng) {
        EventBus.$emit("onShowMsgBox", "휴대전화번호가 인증을 진행 중 입니다.","인증완료 후 정보 변경을 진행하여 주세요.");
        return;
      }

      if (this.editedItem.Pwd == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","계정 확인을 위해 기존 비밀번호를 입력하여 주세요.");
        return;
      }

      let TestBirth = this.CustomInfo.Birth.substring(5,7) + this.CustomInfo.Birth.substring(8,10)

      // if (!this.CheckPW(this.editedItem.Pwd,this.CustomInfo.CustomNickId,TestBirth)) {
      //   return;
      // }

      if (this.editedItem.Pwd1 != "" || this.editedItem.Pwd2 != "") {
        if (this.editedItem.Pwd1 == "") {
          EventBus.$emit("onShowMsgBox", "신규 비밀번호가 입력되지 않았습니다.","신규 비밀번호를 입력하여 주세요.");
          return
        }

        if (!this.CheckPW(this.editedItem.Pwd1,this.CustomInfo.CustomNickId,TestBirth)) {
          return;
        }

        if (this.editedItem.Pwd2 == "") {
          EventBus.$emit("onShowMsgBox", "비밀번호 확인이 입력되지 않았습니다.","신규 비밀번호와 동일하게 입력하여 주세요.");
          return
        }
        if (!this.CheckPW(this.editedItem.Pwd2,this.CustomInfo.CustomNickId,TestBirth)) {
          return;
        }
        if (this.editedItem.Pwd1 != this.editedItem.Pwd2){
          EventBus.$emit("onShowMsgBox", "비밀번호가 일치하지 않습니다.","신규 비밀번호와 확인 칸을 확인하여 주세요.");
          return
        }
      }

      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          this.editedItem.FileId = res.data.FileId;
          this.editedItem.Path = res.data.Path;
        } else {
          EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!");
          this.loading = false;
          return;
        }
      }

      let bChangePwd = ""
      if (this.editedItem.Pwd1 != "" || this.editedItem.Pwd2 != ""){
        bChangePwd = "Y"
      } else {
        bChangePwd = "N"
      }

      var posData = {
        CustomId : this.CustomInfo.CustomId,
        CustomNickId : this.CustomInfo.CustomNickId,
        Pwd : this.cAES256Encrypt(this.editedItem.Pwd),
        NewPwd : this.cAES256Encrypt(this.editedItem.Pwd1),
        ChangePwd : bChangePwd,
        FileId : this.editedItem.FileId,
        Email : this.editedItem.Email,
        Tel : this.editedItem.Tel,
        Code : this.editedItem.cCode,
        AuthType : this.editedItem.cAuthType,
        AuthDI : this.editedItem.cAuthDI,
        CarNo : this.editedItem.CarNo,
        CarType : this.editedItem.CarType,
        Path : this.editedItem.Path,
      };

      axios
        .post(BasicInfo.UIL_API + "EditCustomInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.Initialize();

            EventBus.$emit("onGoChangeImg",BasicInfo.FILE_API,this.editedItem.Path);
            EventBus.$emit("onShowMsg",false, "회원정보 수정이 완료되었습니다.");
          } else if (res.data.ResultCd == "04") {
            EventBus.$emit("onShowMsgBox", "존재하지 않는 아이디 입니다.","로그인 화면으로 이동 합니다.");
            this.$store.dispatch('logout',"CustomChange1");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox", "아이디 또는 비밀번호가 잘못 되었습니다.","로그인 하신 아이디와 비밀번호를 다시 확인하여 주세요.");
          } else if (res.data.ResultCd == "12") {
            EventBus.$emit("onShowMsgBox", "이미 가입된 회원정보가 있습니다.",res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    // 회원정보 삭제하기
    DelCustom() {
      var posData = {
        CustomId : this.CustomInfo.CustomId,
      };
      axios
        .post(BasicInfo.UIL_API + "DelCustom", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "00") {
            this.dialog = false;
            this.$store.dispatch('logout',"CustomChange2");
            EventBus.$emit("onShowMsg",false, "아이디가 삭제되었습니다.");
          } else if (res.data.ResultCd == "02"){
            this.dialog = false;
            this.$store.dispatch('logout',"CustomChange3");
            EventBus.$emit("onShowMsgBox","이미 삭제된 아이디 입니다.","로그인 화면으로 이동합니다.");
          } else {
            EventBus.$emit("onShowMsg",true,res.data.ResultCd + "): "+res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    // 데이터 초기화 하기
    Initialize(){
      this.bCertifyE = false
      this.bCertifyP = false
      this.bPwd = true
      this.bPwd1 = true
      this.bPwd2 = true
      this.cCodeP = ""
      this.editedItem.Pwd = ""
      this.editedItem.Pwd1 = ""
      this.editedItem.Pwd2 = ""
      this.ResetCertify()
      // this.cCertifyTime = ""
    },
  }
}
</script>

<style scoped>
  .test_password_style { 
    -webkit-text-security:disc; 
  }

  div :deep(.v-messages__message) {
    -webkit-text-security:none;
  }

  div :deep(.v-input__append-inner) {
    -webkit-text-security:none;
  }
</style>